import { createAction } from 'redux-actions';

import { keyTransform } from 'util/helper';

import { wrapFetch } from './endpoint';

export const getLocationData = createAction('FETCH_LOCATION_DATA', async (lan, hotel) => {
	const { status, message, data: { data } } = await wrapFetch(
		`api/v1/web/${lan}/${hotel}/transportation`,
		{
			method: 'GET',
		},
	);

	if (status !== 200) {
		throw new Error(message);
	}

	return {
		...keyTransform(data),
	};
});



// WEBPACK FOOTER //
// ./src/actions/location.js